// @flow
import * as React from 'react';
import { Box } from 'grommet';
import EditIcon from 'esm-web-pro/components/icons/EditIcon';
import MapUser from './MapUser';


type Props = {
    user: Object | null,
    editedBy: {
        id: string,
        active: boolean,
    } | null,
    title: string,
    action: string,
}

const margin = { left: 'xsmall' };

const EditedByIndicator = ({
    user, editedBy, title, action,
}: Props) => {
    if (!editedBy) {
        return null;
    }

    return (
        <Box align="center" direction="row" margin={margin}>
            <Box title={title}>
                <EditIcon />
            </Box>
            {user && (
                <MapUser user={user} active={editedBy.active} action={action} />
            )}
        </Box>
    );
};

export default EditedByIndicator;
